import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'matchProperty'
})
export class MatchPropertyPipe implements PipeTransform {
	transform(value: any[], args: any[]) {
		if (value) {
			if (args[1] === '*') {
				return value;
			} else {
				return value.filter(item => {
					return item[args[0]].toString().toLowerCase() === args[1].toString().toLowerCase();
				});
			}
		}
	}
}
